import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {MyStorageService} from "../../services/common/my-storage.service";
import {Utilities} from "../../utils/utilities";

@Component({
  selector: "app-fixed-plugin",
  templateUrl: "./fixed-plugin.component.html",
  styleUrls: ["./fixed-plugin.component.scss"]
})
export class FixedPluginComponent implements OnInit {
  public state: boolean = true;
  isProduction: boolean;
  turnOffTranslations: boolean;
  turnOffMenuItemsCheck: boolean;
  constructor(public toastr: ToastrService,
  private window: Window,
  private myStorage: MyStorageService) {}


  translateOnOff() {
    if (!this.turnOffTranslations){
      this.myStorage.deleteFromCookies('turnOffTranslations');
    }
    else{
      this.myStorage.saveToCookies('turnOffTranslations', 'y');
    }
    this.window.location.reload();
  }

  menuItemsCheckOnOff() {
    if (!this.turnOffMenuItemsCheck){
      this.myStorage.deleteFromCookies('turnOffMenuItemsCheck');
    }
    else{
      this.myStorage.saveToCookies('turnOffMenuItemsCheck', 'y');
    }
    this.window.location.reload();
  }

  ngOnInit() {
    this.turnOffTranslations = this.myStorage.checkKey('turnOffTranslations');
    this.turnOffMenuItemsCheck = this.myStorage.checkKey('turnOffMenuItemsCheck');
  }

}
